import APIUtils from './APIUtils';

class MemberAPI {
    static createWriter(data) {
        return APIUtils.POST('/api/writer/create', data).then(response => {
            return response.data;
        });
    }

    static createMember(data) {
        return APIUtils.POST('/api/members/create', data).then(response => {
            return response;
        });
    }

    static updateWriter(id, data) {
        return APIUtils.POST(`/api/writer/${id}/update`, data).then(response => {
            return response.data;
        });
    }

    static updateMember(id, data) {
        return APIUtils.POST(`/api/members/${id}/update`, data).then(response => {
            return response;
        });
    }

    static getWriter(id) {
        return APIUtils.POST(`/api/writer/${id}`, {}).then(response => {
            return response.data;
        });
    }

    static getBankGroupList() {
        return APIUtils.POST('/api/members/bank/bank_group_list', {}).then(response => {
            return response.data;
        });
    }

    static getListGameProviders() {
        return APIUtils.POST('/api/member_game_providers', {}).then(response => {
            return response.data;
        });
    }

    static getBank() {
        return APIUtils.POST('/api/members/bank/bank_list', {}).then(response => {
            return response.data;
        });
    }

    static updatePassword(id, data) {
        return APIUtils.POST(`/api/members/${id}/update_password`, data).then(response => {
            return response.data;
        });
    }

    static updateStatusInCompanyPage(id, data) {
        return APIUtils.POST(`/api/companies/members/${id}/update_status`, data).then(response => {
            return response.data;
        });
    }

    static updateStatusByAdmin(id, data) {
        return APIUtils.POST(`/api/members/${id}/update_status`, data)
            .then(response => response);
    }

    static updateMemberCredit(id, data) {
        return APIUtils.POST(
            `/api/members/${id}/update_credit`, data
        ).then(response => response);
    }

    static updateMemberCreditNew(id, data) {
        return APIUtils.POST(
            `/api/members/${id}/update_credit_new`, data
        ).then(response => response);
    }

    static getListMembersDownlineInCompanyPage(id, data) {
        return APIUtils.POST(
            `/api/companies/members/${id}/downline`, data
        ).then(response => response);
    }

    static getListWriterReferralDetail(data) {
        return APIUtils.POST(
            '/api/reports/writer_referral/details', data
        ).then(response => response)
            .catch(e => e);
    }

    static getListMembersDownlineInGlobalMemberList(id, data) {
        return APIUtils.POST(
            `/api/members/${id}/downline`, data
        ).then(response => response);
    }


    static getTransactionHistoryType() {
        return APIUtils.POST('/api/members/transaction_history/transaction_types', {})
            .then(response => response)
            .catch(e => e);
    }

    static getTransactionHistoryInCompanyPageByMemberId(memberId, data, format = 'html') {
        return APIUtils.POST(`/api/companies/members/${memberId}/transaction_history/${format}`, data)
            .then(response => response);
    }

    static getTransactionHistoryInGlobalMemberListByMemberId(memberId, data) {
        return APIUtils.POST(`/api/members/${memberId}/transaction_history`, data)
            .then(response => response);
    }

    static getTransactionDetails(memberId, betId) {
        return APIUtils.POST(`/api/members/${memberId}/transaction_history/${betId}`)
            .then(response => response)
            .catch(e => e);
    }

    static getPragmaticDetails(memberId, transactionId) {
        return APIUtils.POST(`/api/members/${memberId}/transaction_history/pragmatic/${transactionId}`)
            .then(response => response);
    }

    static createManualDW(memberId, data) {
        return APIUtils.POST(`/api/members/${memberId}/create_manual_dw`, data)
            .then(response => response);
    }

    static getListCompaniesBankAccount(memberId) {
        return APIUtils.POST(`/api/members/${memberId}/upline_bank_account`)
            .then(response => response);
    }

    static getMemberBankAccount() {
        return APIUtils.POST('/api/members/upline_bank_account')
            .then(response => response);
    }

    static getGameDetail(memberId, game = 'ion', transactionId, query = null) {
        if (query) {
            return APIUtils.POST(`/api/members/${memberId}/transaction_history/${game}/${transactionId}?${query}`)
                .then(response => response);
        }

        return APIUtils.POST(`/api/members/${memberId}/transaction_history/${game}/${transactionId}`)
            .then(response => response);
    }

    static exportListMember(type = 'xlsx', data) {
        return APIUtils.POST(`/api/members/export/${type}`, data, type)
            .then(response => response);
    }

    static getListMemberBankAccount(memberId) {
        return APIUtils.POST(`/api/members/${memberId}/list_member_bank_account`)
            .then(response => response);
    }

    static getListMemberTypesTransaction() {
        return APIUtils.POST('/api/members/transaction_history/transaction_types')
            .then(response => response);
    }

    static getGameDetailSBO(memberId, transactionId, query) {
        return APIUtils.POST(`/api/members/${memberId}/transaction_history/sbo/${transactionId}?${query}`)
            .then(response => response);
    }

    static getListMemberPaymentAccounts(memberId, bankGroupId) {
        return APIUtils.POST(`/api/members/${memberId}/payment_accounts`, { bank_group: bankGroupId })
            .then(response => response);
    }

    static getMember(id) {
        return APIUtils.POST(`/api/members/${id}`, {}).then(response => {
            return response;
        });
    }

    static createMemberPaymentAccounts(memberId, data) {
        return APIUtils.POST(`/api/members/${memberId}/payment_accounts/create`, data)
            .then(response => response);
    }

    static updateMemberPaymentAccounts(memberId, bankId, data) {
        return APIUtils.POST(`/api/members/${memberId}/payment_accounts/${bankId}/update`, data)
            .then(response => response);
    }

    static deleteMemberPaymentAccounts(memberId, bankId) {
        return APIUtils.POST(`/api/members/${memberId}/payment_accounts/${bankId}/delete`)
            .then(response => response);
    }

    static updateMemberBankGroup(memberId, data) {
        return APIUtils.POST(`/api/members/${memberId}/update_bank_group`, data)
            .then(response => response);
    }

    static getListMemberTrackingClone(data) {
        return APIUtils.POST('/api/members/tracking_cloned', data)
            .then(response => response);
    }

    static removeWhatsappNumber(memberId) {
        return APIUtils.POST(`/api/members/${memberId}/remove-whatsapp-number`)
            .then(response => response);
    }

    // KYC Program
    static getMemberKYCInfo(memberId) {
        return APIUtils.POST(`/api/companies/members/${memberId}/kyc/info`)
            .then(response => response);
    }

    // status = reject or approve
    static updateStausMemberKYCInfo(memberId, data, statusKYC = 'approve') {
        return APIUtils.POST(`/api/companies/members/${memberId}/kyc/${statusKYC}`, data)
            .then(response => response);
    }

    static updateActiveDeActiveReferral(id, data) {
        return APIUtils.POST(`/api/companies/members/${id}/enable_referral`, data)
            .then(response => response);
    }

    static downloadCompaniesMemberDownLine(id, type, data) {
        return APIUtils.POST(`/api/companies/members/${id}/downline/${type}`, data).then(response => {
            return response;
        });
    }

    static getUnreadTrackingClonedList(data) {
        return APIUtils.POST('/api/members/unread_tracking_cloned_list', data)
            .then(response => response);
    }

    static getMemberTiers(data = {}) {
        return APIUtils.POST('/api/member_tiers/list', data)
            .then(response => response);
    }

    static getMemberTierMaintenanceAdmin(data = {}) {
        return APIUtils.POST('/api/member_tiers/admin_tier_maintenance', data)
            .then(response => response);
    }

    static getMemberTiersConfig(data = {}) {
        return APIUtils.POST('/api/member_tiers/config', data)
            .then(response => response);
    }

    static checkEnabledMemberTiers(data = {}) {
        return APIUtils.POST('/api/member_tiers/is_enabled', data)
            .then(response => response);
    }

    static updateTierMinAmountConfig(data = {}) {
        return APIUtils.POST('/api/member_tiers/config/min_total_amount/update', data)
            .then(response => response);
    }

    static updateConfigValidity(data = {}) {
        return APIUtils.POST('/api/member_tiers/config/validity/update', data)
            .then(response => response);
    }
    static activeMemberTiers(data = {}) {
        return APIUtils.POST('/api/member_tiers/activate', data)
            .then(response => response);
    }

    static upgradeTierToDiamond(data = {}) {
        return APIUtils.POST('/api/member_tiers/upgrade_to_diamond', data)
            .then(response => response);
    }

    static downgradeTierToBasic(data = {}) {
        return APIUtils.POST('/api/member_tiers/downgrade_to_basic', data)
            .then(response => response);
    }

    static getMemberTierHistory(data = {}) {
        return APIUtils.POST('/api/member_tiers/tier_history', data)
            .then(response => response);
    }
}

export default MemberAPI;
